import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_KNOWLEDGE_PARTNER } from '../../../apiCalls/urls/knowledgepartner';
import { GET_LIST } from '../../../apiCalls/urls/common';

export const knowledgePartnerApi = createApi({
    baseQuery,
    tagTypes: ['knowledgePartner'],
    reducerPath: 'knowledgePartnerApi',
    endpoints: (builder) => ({
        getKnowledgePartnerList: builder.query({
            query: (bodyData) => ({
                url: LIST_KNOWLEDGE_PARTNER,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['knowledgePartner'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetKnowledgePartnerListQuery,
    useGetListMutation
} = knowledgePartnerApi;